import { jsx as _jsx } from "react/jsx-runtime";
import { rgba } from 'polished';
import { createContext, useContext } from 'react';
import styled, { css } from 'styled-components';
import { FoundationContextProvider } from '@clds/design-system-foundations';
import { typographyMixin } from '@clds/typography';
import { avatarSizeVariant, avatarTheme } from './theme.js';
export const SizeContext = createContext(undefined);
const AvatarBase = styled.div `
  border-radius: 100%;
  width: ${(props) => avatarSizeVariant(props).width};
  height: ${(props) => avatarSizeVariant(props).width};
  max-width: ${(props) => avatarSizeVariant(props).width};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${(props) => typographyMixin(avatarSizeVariant(props).typography)};
  font-weight: 500;
  background-color: ${(props) => props.theme.palette.secondary};
  border: solid 1px rgba(0, 0, 0, 0.1);
  ${({ backgroundColor }) => backgroundColor &&
    css `
      background-color: ${backgroundColor};
    `};
  ${({ textColor }) => textColor &&
    css `
      border: 1px solid ${rgba(textColor, 0.1)};
      color: ${textColor};
    `};
  > img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
`;
/** Avatar component - can display 3 types of avatr: with image, with icon and with text and can be color customized */
const AvatarCompoundParent = ({ children, size, rootProps, ...rest }) => (_jsx(AvatarBase, { "data-test": "avatar", size: size, ...rest, ...rootProps, children: _jsx(SizeContext.Provider, { value: size, children: children }) }));
export const AvatarIcon = (props) => {
    const size = useContext(SizeContext);
    if (size === undefined) {
        throw new Error('Avatar.Icon should be used inside Avatar');
    }
    const iconSize = avatarTheme[size].iconSize;
    return (_jsx(FoundationContextProvider, { size: iconSize, children: props?.icon }));
};
export const Avatar = Object.assign(AvatarCompoundParent, { Icon: AvatarIcon });
